import swal from 'sweetalert2';

class Ajax {
    request(configParams = {}) {
        const defaults = {
            method:"POST",
            params:{},
            jsonData:{},
            rawData: null,
            headers:{},
            success:function() {},
            failure:function(error) {
                const homeErrors = [
                    "invalid registrar",
                    "invalid judge",
                    "this event has not yet started",
                    "this event has ended"
                ];
                const expectedErrors = [
                    "cannot be blank",
                    "invalid phone number",
                    "invalid email address"
                ];

                swal.fire({
                    title:"Oops!",
                    html: error.toString().charAt(0).toUpperCase() + error.toString().slice(1),
                    icon:"error",
                    didClose: () => {
                        if (homeErrors.some((msg) => error.toString().toLowerCase().includes(msg))) {
                            window.location.href = "/";
                        } else if (!expectedErrors.some((msg) => error.toString().toLowerCase().includes(msg))) {
                            window.location.reload();
                        }
                    }
                });
            }
        };

        const config = {...defaults, ...configParams};

        if(!config.hasOwnProperty("url")) {
            console.error("Url not defined!");
        }

        let fetchConfig = {
            method: config.method,
            headers: config.headers
        };

        if (config.rawData) {
            const formData = new FormData();
            for (const [key, value] of Object.entries(config.rawData)) {
                formData.append(key, value);
            }
            fetchConfig.body = formData;
            if (config.headers['Content-Type']) {
                delete config.headers['Content-Type'];
            }
        } else if(Object.keys(config.jsonData).length > 0) {
            config.headers['Content-Type'] = 'application/json';
            fetchConfig.body = JSON.stringify(config.jsonData);
        } else if(Object.keys(config.params).length > 0) {
            config.headers['Content-Type'] = ' application/x-www-form-urlencoded';
            let formBody = [];
            for (let property in config.params) {
                var encodedKey = encodeURIComponent(property);
                var encodedValue = encodeURIComponent(config.params[property]);
                formBody.push(encodedKey + "=" + encodedValue);
            }
            formBody = formBody.join("&");
            fetchConfig.body = formBody;
        }

        if(Object.keys(config.params).length > 0 && Object.keys(config.jsonData).length > 0) {
            console.error("Cannot define params and jsonData!");
        }

        const currentMaskDisplay = document.getElementById("loading").style.display;
        let hideMaskOnFinish = false;
        if(currentMaskDisplay !== "flex") {
            document.getElementById("loading").style.display = "flex";
            hideMaskOnFinish = true;
        }

        fetch(config.url, fetchConfig)
        .then((response) => {
            if(response.ok) {
                return response.text()
            } else {
                return response.text().then(error => {
                    try {
                        error = JSON.parse(error);
                        if(error.hasOwnProperty("error")) {
                            return Promise.reject(error.error);
                        }
                    } catch(e) {
                        return Promise.reject(error);
                    }
                });
            }
        })
        .then((reply) => {
            try {
                reply = JSON.parse(reply.toString());
                if(reply.hasOwnProperty("success")) {
                    if(reply.success) {
                        if(hideMaskOnFinish) {
                            document.getElementById("loading").style.display = "none";
                        }
                        config.success(reply);
                    } else {
                        if(hideMaskOnFinish) {
                            document.getElementById("loading").style.display = "none";
                        }
                        config.failure(reply.error);
                    }
                }
            } catch(err) {
                if(hideMaskOnFinish) {
                    document.getElementById("loading").style.display = "none";
                }
                config.failure(reply);
            }
        })
        .catch((err) => {
            if(hideMaskOnFinish) {
                document.getElementById("loading").style.display = "none";
            }
            config.failure(err);
        });
    }
}

const ajax = new Ajax();
export default ajax;